module.exports = __webpack_public_path__ + "media/store/fonts/LaplaceMonoWeb-Italic-0364d08cbeefbe03392408e833934d65.woff";